module.exports = __webpack_public_path__ + "static/media/rec-room-802017_1920.5849f0c2.jpg";